const randomColor = require('randomcolor'); // import the script

export const stringToColor = {
    data() {
        return {
            primaryColors: ['#F5F6FD', '#E2E9F9', '#8DA5E6', '#5478D9', '#2A52BE', '#224299', '#193172'],
            secondaryColors: ['#D3F8F7', '#A7F1EF', '#7BEAE7', '#2DDCD7', '#22B1AD', '#178582', '#106866'],
            shiftColors: [
                '#9eb5f6',
                '#5cc7ff',
                '#00DAF1',
                '#23EDC9',
                '#9CF896',
                '#F9F871',
                '#F6F2CB',
                '#FFCB65',
                '#FFA175',
                '#FF808E',
                '#D86DA4',
                '#9B66AD',
            ],
            // Brand palette offered in the shift colour-picker (ShiftForm).
            brandShiftColors: ['#8DA5E6', '#2A52BE', '#193172', '#7BEAE7', '#1CB1AD', '#116866'],
        }
    },
    methods: {
        stringToHslColor(str, s = 30, l = 50) {
            if (!str) {
                return
            }
            if (str === 'gr') {
                return '#c7c7c7'
            }
            if (str === 'suspended') {
                return '#9f9f9f'
            }
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }

            let h = hash % 360;
            return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
        },
        stringToShiftColor(str, palette = this.shiftColors) {
            if (!str) {
                return
            }
            if (str === 'gr') {
                return '#c7c7c7'
            }
            if (str === 'suspended') {
                return '#9f9f9f'
            }
            // Derive the palette index deterministically from the string, so the
            // same shift always maps to the same colour regardless of the order
            // in which shifts are rendered/loaded (otherwise colours shuffle per refresh).
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            const index = Math.abs(hash) % palette.length;
            return palette[index];
        },
        // Pick a readable text colour (dark or white) for a given hex background,
        // so labels stay legible on both light and dark shift colours.
        shiftTextColor(backgroundColor) {
            if (!backgroundColor || backgroundColor[0] !== '#') {
                return '#333333';
            }
            let hex = backgroundColor.slice(1);
            if (hex.length === 3) {
                hex = hex.split('').map(c => c + c).join('');
            }
            const r = parseInt(hex.slice(0, 2), 16);
            const g = parseInt(hex.slice(2, 4), 16);
            const b = parseInt(hex.slice(4, 6), 16);
            // Perceived brightness (sRGB weighting); light backgrounds get dark text.
            const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            return brightness > 0.6 ? '#1a1a1a' : '#ffffff';
        },
    }
};
